module.exports = __webpack_public_path__ + "img/default-avatar.f386fe79.png";